export const MAX_DRIVER_WEIGHT = 550;
export const MIN_DRIVER_WEIGHT = 0;
